import * as React from 'react';
import { Outlet, useParams } from 'react-router-dom';
import _toInteger from 'lodash/toInteger';
import { FlightOperationNotificationDataProvider } from '../../core/context/FlightOperationNotificationDataContext';
import { AuthorizationRequestType } from '../../core/api/clients';
import { FlightOperationNotificationFieldOptionsProvider } from '../../core/context/FlightOperationNortificationFieldOptionContext';

function FlightOperationNotificationLayout() {
  const { formId } = useParams<'formId'>();
  const { action } = useParams<'action'>();

  let requestType = AuthorizationRequestType.Contribute;
  if (action === 'approve') {
    requestType = AuthorizationRequestType.Approve;
  } else if (action === 'read') {
    requestType = AuthorizationRequestType.Read;
  } else if (action === 'view') {
    requestType = AuthorizationRequestType.View;
  }

  return (
    <div>
      <FlightOperationNotificationDataProvider flightOperationNotificationId={_toInteger(formId)} role={requestType}>
        <FlightOperationNotificationFieldOptionsProvider>
          <Outlet />
        </FlightOperationNotificationFieldOptionsProvider>
      </FlightOperationNotificationDataProvider>
    </div>
  );
}

export default FlightOperationNotificationLayout;
